import { render, staticRenderFns } from "./data.vue?vue&type=template&id=b0d8992e&scoped=true"
import script from "./data.vue?vue&type=script&lang=ts"
export * from "./data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d8992e",
  null
  
)

export default component.exports